export const SGA_SPEND_SCHEMA_VERSION_BY_LEVER = {
  professional_fees: 'professional_fees_governed_snapshot_v1',
  outside_contractors: 'outside_contractors_governed_snapshot_v1',
  indirect_procurement: 'indirect_procurement_governed_snapshot_v1',
  travel_and_expense: 'travel_expense_governed_snapshot_v1',
  shared_services: 'shared_services_governed_snapshot_v1',
  tech_software: 'tech_software_governed_snapshot_v1',
  real_estate_footprint: 'real_estate_footprint_governed_snapshot_v1',
  marketing_spend: 'marketing_spend_governed_snapshot_v1',
} as const;

export const SGA_SPEND_SCHEMA_VERSIONS = {
  manifest: 'decision_agent_module_manifest_v1',
  financePnlGovernedSnapshot: 'finance_pnl_governed_snapshot_v1',
  costPoolMapping: 'sga_cost_pool_mapping_v1',
  industryReferencePack: 'industry_reference_pack_v1',
  ownerMap: 'sga_spend_owner_map_v1',
  controlPlan: 'sga_spend_control_plan_v1',
  governedFloor: 'sga_spend_q04_governed_floor_v1',
  strategyAttachableFinding: 'strategy_attachable_finding_v1',
} as const;

export type SgaSpendSchemaVersion =
  (typeof SGA_SPEND_SCHEMA_VERSION_BY_LEVER)[keyof typeof SGA_SPEND_SCHEMA_VERSION_BY_LEVER];
